<div class="modal-container">
  <suite-rfb-collapse [title]="titulo">
    <div class="container-fluid container-filtros">
      <via-pesquisa-cnpj></via-pesquisa-cnpj>
    </div>
  </suite-rfb-collapse>
</div>
